import React, { useState, useEffect, useContext } from "react";
import { Box, Heading, Text, Layer, Image, Button, DataTable, TextInput, CheckBox } from "grommet";
import { Link, useHistory } from "react-router-dom";
import { Search } from "grommet-icons";
import firebase from "firebase/app";
import UserContext from "../context/UserContext";

const Transactions = () => {
	const history = useHistory();

	const { authUser } = useContext(UserContext);

	const [data, setData] = useState([]);
	const [filtered, setFiltered] = useState([]);

	useEffect(() => {
		firebase
			.firestore()
			.collection("transactions")
			.where("owner", "==", authUser.owner)
			.get()
			.then((querySnapshot) => {
				const res = querySnapshot.docs.map((doc) => ({ ...doc.data(), id: doc.id }));
				setData(res);
				setFiltered(res);
			});
	}, []);

	return (
		<Box flex="grow" background="#F6F6F6" pad="medium" gap="medium">
			{/* SECCION ULTIMAS PROMO */}

			<Box gap="medium" width="100%" background="white" pad="medium" elevation="medium" round="10px">
				<Box direction="row">
					<Box flex={true}>
						<Heading margin="0px" level="3" color="#170747">
							Transacciones
						</Heading>
					</Box>
					{/* <Box direction="row" gap="small" align="center">
						<Button onClick={() => history.push("/newpromotion")} style={{ color: "white", fontWeight: "600", textAlign: "center", paddingLeft: 15, paddingRight: 15, height: 35, borderRadius: 5, alignItems: "center", justifyContent: "center" }} primary color="brand">
							Nueva Promoción
						</Button>
					</Box> */}
				</Box>

				<Box height="2px" round="small" background="gainsboro" width="100%" />

				{/* SEARCH BOX */}
				<Box direction="row" gap="small">
					<TextInput icon={<Search />} placeholder="Buscar Promociones..." onChange={(ev) => setFiltered(data.filter((el) => el.name.toLocaleLowerCase().includes(ev.target.value.toLocaleLowerCase()) || el.brand.toLocaleLowerCase().includes(ev.target.value.toLocaleLowerCase())))} />
					{/* <Button style={{ border: "2px solid #170747", color: "#170747", fontWeight: "600", textAlign: "center", paddingLeft: 15, paddingRight: 15, borderRadius: 5, alignItems: "center", justifyContent: "center" }} color="#170747">
						Filtrar
					</Button>
					<Button style={{ border: "2px solid #170747", color: "#170747", fontWeight: "600", textAlign: "center", paddingLeft: 15, paddingRight: 15, borderRadius: 5, alignItems: "center", justifyContent: "center" }} color="#170747">
						Ordenar
					</Button> */}
				</Box>

				<Box margin={{ top: "10px" }}>
					<DataTable
						onClickRow={({ datum }) => history.push("/editpromotion/" + datum.id)}
						columns={[
							{
								property: "check",
								header: <CheckBox />,
								render: (datum) => <CheckBox />,
							},
							{
								property: "id",
								header: <Text>Transacción</Text>,
								sortable: true,
								render: (datum) => (
									<Text style={{ fontWeight: 600 }} color="secondary">
										ID: {datum.id}
									</Text>
								),
							},
							{
								property: "promotion",
								header: "Promoción",
								primary: true,
								render: (datum) => <Box pad={{ vertical: "xsmall" }}>{datum.promotionName}</Box>,
							},
							{
								property: "date",
								header: "Fecha",
								render: (datum) => (
									<Box pad={{ vertical: "xsmall" }}>
										<Button color={datum.status ? "brand" : "status-critical"} style={{ textAlign: "center", paddingTop: 5, paddingBottom: 5 }} primary>
											{datum.status ? "Activo" : "Inactivo"}
										</Button>
									</Box>
								),
							},
							{
								property: "status",
								header: "Estatus",
								render: (datum) => (
									<Box pad={{ vertical: "xsmall" }}>
										<Button color={datum.status ? "brand" : "status-critical"} style={{ textAlign: "center", paddingTop: 5, paddingBottom: 5 }} primary>
											{datum.status ? "Activo" : "Inactivo"}
										</Button>
									</Box>
								),
							},
						]}
						data={filtered}
					/>
					<Box height="300px" width="100%" align="center" justify="center" round="small" background="#f3f3f3" margin={{top:"2px"}}>
						<Text>No ha habido transacciones recientemente</Text>
					</Box>
				</Box>
			</Box>
		</Box>
	);
};

export default Transactions;
